/** Toggle off (or delete this file + stepper imports) to revert the mobile layout experiment. */
export const OVERVIEW_PARTS_STEPPER_EXPERIMENT = true;
